import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { description } from 'src/app/models/books.model';
import { BookService } from 'src/app/services/book.service';
import { FormsModule } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { iUser } from 'src/app/models/user.model';
import { mesiLista } from './mesi';

@Component({
  selector: 'app-editori-anni',
  templateUrl: './editori-anni.component.html',
  styleUrls: ['./editori-anni.component.scss'],
})
export class EditoriAnniComponent implements OnInit {
  @Input() user: iUser;
  @Input() titles: string[];
  @Input() icons: string[];
  @Input() isEditore: boolean = false;
  currentIndex = 0;
  selected = {
    anno: null,
    editore: 0,
    mese: null,
  };
  loadingObj = {
    editori: false,
    download: false,
  };
  editori = [];
  anni = [];
  mesi = mesiLista;

  constructor(
    private bookservice: BookService,
    private toast: ToastrService
  ) {}

  ngOnInit(): void {
    this.anni = Array.from({ length: 5 }, (_, i) => {
      const year = moment().subtract(i, 'years').year();
      return {
        cod: year,
        descrizione: moment()
          .subtract(i, 'years')
          .format('YYYY'),
      };
    }).reverse();

    this.getEditori();
  }

  /**
   * Funzione che si occupa del caricamento degli autori
   */
  getEditori() {
    this.loadingObj.editori = true;
    this.bookservice.editoriReport().subscribe({
      next: (data: description[]) => {
        this.editori = data;
      },
      error: (err) => {
        console.error(err);
      },
      complete: () => (this.loadingObj.editori = false),
    });
  }

  /**
   * Funzione gestisce il download del file causali [61,62,2,4]
   * Periodi del file con es Novembre 2025 
   * Anno precedente: 1-11-2023 -- 31-10-2024
   * Anno in corso: 1-11-2024 -- 31-10-2025
   */
  downloadReport() {
    this.loadingObj.download = true;
    const url = `${this.selected.mese}/${
      this.selected.anno
    }${
      this.isEditore || this.selected.editore === 0
        ? ''
        : `/${this.selected.editore}`
    }`;

    this.bookservice
      .getResourceFile(`report/gvr${!this.isEditore ? '/editore' : ''}`, url)
      .subscribe({
        next: (data: any) => {
          const blob = new Blob([data], {
            type: 'application/json',
          });
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          const editore = this.editori.filter(
            (el) => el.cod === this.selected.editore
          );
          a.download = `rendimento_magazzino_${
            this.selected.anno
          }_${
            this.isEditore
              ? ''
              : editore[0]?.descrizione ?? 'tutti'
          }.xlsx`;
          a.click();
        },
        error: (err) => {
          this.toast.error(
            `Contattare l'assistenza`,
            `Errore nel downaload del report`
          );
          console.error(err);
        },
        complete: () => {
          this.loadingObj.download = false;
        },
      });
  }
}
